'use client';

import { useState } from 'react';
import { useRouter } from 'next/navigation';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { Search } from 'lucide-react';

interface HelpSearchBarProps {
  defaultValue?: string;
  placeholder?: string;
  size?: 'default' | 'lg';
}

export function HelpSearchBar({
  defaultValue = '',
  placeholder = 'Search help articles...',
  size = 'default',
}: HelpSearchBarProps) {
  const [query, setQuery] = useState(defaultValue);
  const router = useRouter();

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    if (query.trim()) {
      router.push(`/help/search?q=${encodeURIComponent(query.trim())}`);
    }
  };

  return (
    <form onSubmit={handleSearch} className="w-full">
      <div className="relative flex gap-2">
        <div className="relative flex-1">
          <Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" />
          <Input
            type="search"
            placeholder={placeholder}
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            className={
              size === 'lg'
                ? 'h-12 pl-10 text-lg'
                : 'pl-10'
            }
          />
        </div>
        <Button
          type="submit"
          size={size === 'lg' ? 'lg' : 'default'}
          disabled={!query.trim()}
        >
          Search
        </Button>
      </div>
    </form>
  );
}
